import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ABAQ Webapp';

  showNavbar = true;

  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      const publicFormRoutes = [
        '/formularios/placas',
        '/formularios/platicas',
        '/formularios/campanas',
        '/formularios/adopciones',
      ];

      const isPublicForm = publicFormRoutes.some((route) =>
        this.router.url.startsWith(route),
      );
      const isAuthOrOnboarding =
        this.router.url.startsWith('/auth/') ||
        this.router.url.startsWith('/onboarding/');

      this.showNavbar = !isAuthOrOnboarding && !isPublicForm;

      if (typeof document !== 'undefined') {
        document.body.classList.toggle('no-navbar-padding', !this.showNavbar);
      }
    });
  }
}
